import type { ComponentProps } from "react";

/** Native keyboard and touch behavior with a consistently inset caret. */
export function NativeSelect({ className, wrapperClassName, children, ...props }: ComponentProps<"select"> & { wrapperClassName?: string }) {
  return (
    <span className={`relative block ${wrapperClassName ?? ""}`}>
      <select {...props} className={`appearance-none pr-9 ${className ?? ""}`}>
        {children}
      </select>
      <svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
        <path d="m6 9 6 6 6-6" />
      </svg>
    </span>
  );
}
